<ul class="nav navbar-nav top-navbar" *ngIf="routesFlag">
  <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" *ngFor='let routerpath of routesFlag'>
    <a [routerLink]="routerpath.isClickable ? routerpath.routeURL:null" [ngClass]="routerpath.isClickable ? 'cursor-pointer':'disabled'" (click)="routerpath.isClickable ? routeClicked() : $event.preventDefault()">
      <span class="menu-title">{{routerpath.routeName}}</span>
    </a>
  </li>
  <!-- <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="dropdown" *ngIf="isHSEAdvisor && reportRoutes.length > 0">
    <a class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
      <span class="menu-title">Reports
        <span class="caret"></span>
      </span>
    </a>
    <ul class="dropdown-menu sub-menu">
      <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" *ngFor='let reportPath of reportRoutes'>
        <a routerLink={{reportPath.routeURL}}>{{reportPath.routeName}}</a>
      </li>
    </ul>
  </li> -->
</ul>
